/**
 * Emergency unpause a market (resolver only)
 */
import type { Address, Hash, WalletClient } from "viem"
import { breakoutMarketAbi } from "../../abi/generated/breakoutMarket"
import { getAccount } from "../../internal/contracts"

export interface EmergencyUnpauseParams {
	market: Address
}

/**
 * Emergency unpause a market
 *
 * Can only be called by the resolver. Resumes trading if market was paused.
 *
 * @example
 * ```ts
 * import { emergencyUnpause } from "@breakout/sdk/actions/write"
 *
 * const txHash = await emergencyUnpause(walletClient, { market: "0x..." })
 * ```
 */
export async function emergencyUnpause(
	client: WalletClient,
	params: EmergencyUnpauseParams,
): Promise<Hash> {
	const account = await getAccount(client)

	return client.writeContract({
		address: params.market,
		abi: breakoutMarketAbi,
		functionName: "emergencyUnpause",
		args: [],
		account,
		chain: client.chain,
	})
}
